import { Link } from "react-router-dom";

/**
 * Rendered above the chart when `resolutionLocked` is true — i.e. the selected
 * range would show hourly detail on a premium plan, but this account is on free tier
 * and is seeing a single collapsed bar instead.
 */
const PremiumCallout = ({ billingPath = "/billing" }) => (
  <div className="ea-callout ea-callout--info">
    <div className="ea-callout__text">
      <strong>Want the hour-by-hour breakdown?</strong> See exactly how a single day
      performed — great for tracking a campaign launch in real time.
    </div>
    <Link to={billingPath} className="btn btn-primary text-white ea-callout__cta">
      Upgrade to Pro
    </Link>
  </div>
);

export default PremiumCallout;
